import { ValueType } from 'realgrid';

export const fields = [
    {
        fieldName: 'remove',
        dataType: ValueType.TEXT,
    },
    {
        fieldName: 'name',
        dataType: ValueType.TEXT,
    },
    {
        fieldName: 'email',
        dataType: ValueType.TEXT,
    },
    {
        fieldName: 'idx',
        dataType: ValueType.NUMBER,
    },
    {
        fieldName: 'pt_cd',
        dataType: ValueType.TEXT,
    },
];

export const columns = [
    {
        name: 'remove',
        fieldName: 'remove',
        type: 'data',
        styles: {
            textAlignment: 'center',
        },
        header: {
            text: '삭제',
        },
        renderer: {
            type: 'html',
            callback: function (grid, cell) {
                return '<svg class="delete-post-icon" xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 40 40"><path fill="currentColor" d="M21.499 19.994L32.755 8.727a1.064 1.064 0 0 0-.001-1.502c-.398-.396-1.099-.398-1.501.002L20 18.494L8.743 7.224c-.4-.395-1.101-.393-1.499.002a1.05 1.05 0 0 0-.309.751c0 .284.11.55.309.747L18.5 19.993L7.245 31.263a1.064 1.064 0 0 0 .003 1.503c.193.191.466.301.748.301h.006c.283-.001.556-.112.745-.305L20 21.495l11.257 11.27c.199.198.465.308.747.308a1.058 1.058 0 0 0 1.061-1.061c0-.283-.11-.55-.31-.747z" /></svg>';
            },
        },
        editable: false,
        sortable: false,
        width: 60,
    },
    {
        name: 'name',
        fieldName: 'name',
        type: 'data',
        styles: {
            textAlignment: 'center',
        },
        header: {
            text: '이름',
            showTooltip: false,
        },
        editable: false,
        sortable: false,
        width: 150,
    },
    {
        name: 'email',
        fieldName: 'email',
        type: 'data',
        styles: {
            textAlignment: 'center',
        },
        header: {
            text: '이메일 주소',
            showTooltip: false,
        },
        editable: false,
        sortable: false,
        width: 300,
    },
];

export const rows = [
    {
        remove: '',
        name: '',
        email: '',
    },
];
